function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 =
/*#__PURE__*/
React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M4.8,55.6l9.8-1.3c0.6,4.7,1.8,8.1,3.6,10.2c1.8,2.2,4.2,3.3,7.3,3.3c3.2,0,5.7-1,7.3-2.9 c1.6-1.9,2.5-4.2,2.5-6.8c0-1.7-0.3-3.1-1-4.3c-0.7-1.2-1.9-2.2-3.6-3.1c-1.2-0.6-3.9-1.6-8-3.1c-5.4-1.9-9.2-4.2-11.3-7 c-3.1-3.9-4.6-8.6-4.6-14.2c0-3.6,0.7-7,2.2-10.1s3.5-5.5,6.2-7.1c2.7-1.6,6-2.5,9.8-2.5c6.2,0,10.9,1.9,14.1,5.8 c3.2,3.9,4.8,9.1,5,15.5l-10,0.6c-0.4-3.6-1.4-6.2-2.8-7.8c-1.4-1.6-3.5-2.4-6.4-2.4c-2.9,0-5.2,0.8-6.9,2.5 c-1.1,1.1-1.6,2.6-1.6,4.4c0,1.7,0.5,3.1,1.5,4.3c1.3,1.5,4.3,3.1,9.2,4.7s8.5,3.3,10.8,5.1c2.3,1.7,4.2,4.1,5.5,7.2 c1.3,3,2,6.8,2,11.2c0,4-0.8,7.8-2.4,11.4c-1.6,3.5-3.8,6.2-6.7,7.9c-2.9,1.7-6.5,2.6-10.8,2.6c-6.3,0-11.1-2.1-14.5-6.2 C7.5,69.5,5.5,63.5,4.8,55.6z"
}), React.createElement("rect", {
  x: 109.6,
  y: 8,
  className: "st0",
  width: 10,
  height: 43.4
}), React.createElement("g", null, React.createElement("path", {
  className: "st0",
  d: "M80,72.5c0-3.6,0.4-6.6,1.1-9.1c0.5-1.8,1.2-3.4,2.2-4.9c0.9-1.4,1.9-2.5,3-3.2c1.4-0.9,3.1-1.4,5-1.4 c3.4,0,6.2,1.6,8.2,4.9c2.1,3.2,3.1,7.8,3.1,13.5c0,5.7-1,10.2-3.1,13.5c-2,3.2-4.8,4.9-8.2,4.9c-3.5,0-6.2-1.6-8.2-4.8 C81,82.6,80,78.1,80,72.5z M84.9,72.3c0,4,0.6,7.1,1.8,9.1s2.8,3.1,4.6,3.1c1.9,0,3.4-1,4.6-3.1c1.2-2.1,1.8-5.1,1.8-9.3 c0-4.1-0.6-7.1-1.7-9.1c-1.2-2-2.7-3-4.6-3c-1.9,0-3.5,1-4.7,3C85.4,65.1,84.9,68.2,84.9,72.3z"
}), React.createElement("path", {
  className: "st0",
  d: "M106.9,90V54.5h15.9v6h-11.2v8.4h9.7v6h-9.7V90H106.9z"
}), React.createElement("path", {
  className: "st0",
  d: "M127.3,90V54.5h15.9v6H132v8.4h9.7v6H132V90H127.3z"
})), React.createElement("path", {
  className: "st0",
  d: "M77.5,66.4c-1.2,0.2-2.6,0.3-4.5,0.3h-7.5V20H70c4.1,0,6.8,0.2,8.2,0.7c1.9,0.6,3.4,1.7,4.6,3.3 c1.2,1.6,2.2,3.9,2.8,6.8c0.7,2.9,1,7.1,1,12.6c0,3.4-0.1,6.3-0.4,8.8c1.3-0.4,2.6-0.7,4.1-0.7h6.4c0.2-2.3,0.3-4.8,0.3-7.5 c0-6.6-0.5-12.2-1.6-16.7c-1.1-4.5-2.7-8.3-4.7-11.4c-2.1-3.1-4.6-5.3-7.5-6.5C81.1,8.5,78,8,73.8,8H55.5v70.5h18.9 c1.1,0,2.1-0.1,3.1-0.1V66.4z"
}));

var SvgSdiOffIcon = function SvgSdiOffIcon(_ref) {
  var svgRef = _ref.svgRef,
      props = _objectWithoutProperties(_ref, ["svgRef"]);

  return React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 150 96.1",
    style: {
      enableBackground: "new 0 0 150 96.1"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), _ref2);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgSdiOffIcon, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/sdi-off-icon.1e502bc7.svg";
export { ForwardRef as ReactComponent };